import { CategoryActions } from 'common/constants/actions';

const initialState = {
  member_filters: [],
  pending: false,
};

export default function MemberFilters(state = initialState, action) {
  switch (action.type) {
    case CategoryActions.GET_MEMBER_FILTERS:
      return {
        ...state,
        member_filters: action.payload,
        pending: false,
      };

    case CategoryActions.SET_MEMBER_FILTERS:
      return {
        ...state,
        member_filters: action.payload,
        pending: false,
      };

    case CategoryActions.SET_MEMBER_SEARCH_FILTERS:
      return {
        ...state,
        member_filters: action.payload,
        pending: false,
      };

    default:
      return state;
  }
}
